import { render } from "./BaseBadge.vue?vue&type=template&id=bd0ef7c8&scoped=true"
import script from "./BaseBadge.vue?vue&type=script&lang=js"
export * from "./BaseBadge.vue?vue&type=script&lang=js"

import "./BaseBadge.vue?vue&type=style&index=0&id=bd0ef7c8&scoped=true&lang=css"

import exportComponent from "/home/marvi/Рабочий стол/Studies/Udemy/Vue/11_find_a_coach/main-prj-01-starting-setup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd0ef7c8"]])

export default __exports__